import styled from 'styled-components'

export const Layout = styled.div`
  
  main {
    display: flex;
    align-items: center;
    flex-direction: column;
    height: 100vh;
    //background-image: linear-gradient(135deg, rgba(0, 221, 255, 0.73), rgba(89, 0, 255, 0.9));
  }
`